import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface ListStateIconSuccessProps {
  noMargin?: boolean;
  color?: string;
  tooltip?: string;
}

export const ListStateIconSuccess = (props: ListStateIconSuccessProps) => (
    <ListStateIcon
        icon={CheckCircleIcon}
        tooltip={props.tooltip}
        color={props.color}
        noMargin={props.noMargin}
    />
);
